import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type PracticeWalkthroughContextValue = {
  manualNewPracticeRequest: number;
  manualPracticeSessionRequest: number;
  requestManualNewPracticeWalkthrough: () => void;
  requestManualPracticeSessionWalkthrough: () => void;
};

const PracticeWalkthroughContext = createContext<PracticeWalkthroughContextValue | null>(null);

export function PracticeWalkthroughProvider({ children }: { children: ReactNode }) {
  const [manualNewPracticeRequest, setManualNewPracticeRequest] = useState(0);
  const [manualPracticeSessionRequest, setManualPracticeSessionRequest] = useState(0);

  const requestManualNewPracticeWalkthrough = useCallback(() => {
    setManualNewPracticeRequest((n) => n + 1);
  }, []);

  const requestManualPracticeSessionWalkthrough = useCallback(() => {
    setManualPracticeSessionRequest((n) => n + 1);
  }, []);

  return (
    <PracticeWalkthroughContext.Provider
      value={{
        manualNewPracticeRequest,
        manualPracticeSessionRequest,
        requestManualNewPracticeWalkthrough,
        requestManualPracticeSessionWalkthrough,
      }}
    >
      {children}
    </PracticeWalkthroughContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- hook paired with PracticeWalkthroughProvider
export function usePracticeWalkthroughContext(): PracticeWalkthroughContextValue {
  const ctx = useContext(PracticeWalkthroughContext);
  if (!ctx) {
    throw new Error(
      'usePracticeWalkthroughContext must be used within PracticeWalkthroughProvider',
    );
  }
  return ctx;
}
